import React from 'react'
import { Box, Color, Display, FlexDirection, Body1 } from '@gousto-internal/citrus-react'

import type { LoggedOutBoxSummaryActions, LoggedOutBoxSummarySummaryView } from '../types'

type SummaryPanelProps = {
  view: LoggedOutBoxSummarySummaryView
  actions: Pick<
    LoggedOutBoxSummaryActions,
    'onSummaryEditPostcode' | 'onSummaryEditDelivery' | 'onSummaryEditPortionSize' | 'onCheckout'
  >
}

// Scaffold: `actions` is a forward-declared contract the modal already wires up;
// it is intentionally not consumed yet and will be when this panel is built out.
export const SummaryPanel = ({ view }: SummaryPanelProps) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    paddingH={3}
    paddingBottom={6}
    data-testid="logged-out-box-summary-summary-panel"
  >
    <Body1 color={Color.ColdGrey_800}>{view.title}</Body1>
  </Box>
)
